export const formatTaxRate = (ratePpm: number, isoLocale: string): string =>
  new Intl.NumberFormat(isoLocale, { style: "percent", maximumFractionDigits: 4 }).format(ratePpm / 1_000_000);
